<template>
  <transition name="modal">
    <div
      role="dialog"
      class="modal-mask"
      :class="isManager ? 'zi' : ''"
      aria-labelledby="mainModal"
      aria-hidden="true"
      v-show="show"
    >
      <div class="modal-main">
        <div class="modal-dialog modal-dialog-centered" :class="modalSize" role="document">
          <div class="modal-content">
            <div class="modal-header" v-show="header">
              <slot name="header"></slot>
              <button type="button" class="close" aria-label="Close" @click="onClose">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <slot></slot>
            </div>
            <!--  <div class="modal-footer">
              <button type="button" class="btn btn-secondary">Close</button>
              <button type="button" class="btn btn-primary">Save</button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'custom-login-modal',
  data: () => ({
    isManager: false,
  }),
  props: {
    show: {
      type: Boolean,
    },
    modalSize: {
      type: String,
      default: 'modal-lg',
    },
    header: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
  mounted() {
    if (this.$route.path.includes('manager')) {
      this.isManager = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

/* scroll in modal body */

.modal-main {
  height: 100vh;
  overflow-y: auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media only screen and (max-width: 1250px) {
  .modal-content {
    margin-top: 50px;
    z-index: 9999;
  }
}
</style>
